export const isDevPreview = import.meta.env.VITE_DEV_PREVIEW === 'true';
